export default {
  uploads: [],
  uploads_loading: false,
  uploads_submitting: false,
  uploads_error: "",
  active_upload: null,
  is_edit_upload: false,
  has_more: false,
  next_page: 0,
};
